import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import API_CONTACT from '../../../api/apiContact';
import API_SEARCH from '../../../api/apiSearch';
import IconContactCalendar from '../../../assets/icons/IconContactCalendar';
import IconWarehouse from '../../../assets/icons/IconWarehouse';
import IconPhone from '../../../assets/icons/IconPhone';
import IconEmail from '../../../assets/icons/IconEmail';
import IconPeople from '../../../assets/icons/IconPeople';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    CONTACT_LIST_VIEW,
    CONTACT_LIST_UPDATE
} from '../../../constants/menuPermissionConstant';
import SearchbarMenu from '../../../components/Searchbar/SearchbarMenu';
import IconNoContact from '../../../assets/icons/IconNoContact';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isContactOpened: false,
            page: 1,
            limit: 100,
            total: 0,
            contactList: [],
            contactDetail: {},
            showLoadMore: true,
            showEditPicModal: false,
            picData: '',
            name: '',
            phone: '',
            email: '',
            searchBy: '',
            keyword: '',
            showSuccessAlert: false,
            successMessage: '',
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleDetail = id => {
        API_CONTACT.getDetailUserCustomer(id, this.props.token)
            .then(res => {
                this.setState({
                    isContactOpened: true,
                    contactDetail: getContent(res)
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleDetailSearch = () => {
        API_CONTACT.getDetailUserCustomer(this.props.keyword, this.props.token)
            .then(res => {
                this.setState({
                    isContactOpened: true,
                    contactDetail: getContent(res)
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getInitiateUserCustomer = () => {
        API_CONTACT.getInitiateUserCustomer(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        total: getContent(res).count_data
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListUserCustomer = () => {
        API_CONTACT.getListUserCustomer(this.state.page, this.state.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        contactList: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleEditPic = data => {
        this.setState({
            showEditPicModal: true,
            picData: data,
            name: data.pic_name,
            phone: data.pic_phone,
            email: data.email
        })
    }

    handleSearch = async (searchBy, keyword) => {
        if (this.state.searchBy === '' && this.state.keyword === '') {
            await this.setState({
                page: 1,
                searchBy: searchBy,
                keyword: keyword
            })
        } else {
            await this.setState({
                searchBy: searchBy,
                keyword: keyword
            })
        }

        API_SEARCH.getInitiateContact(searchBy, encodeURIComponent(keyword), this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        total: getContent(res).count_data
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))

        API_SEARCH.getDataContact(this.state.page, this.state.limit, searchBy, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        contactList: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleSubmit = e => {
        e.preventDefault();

        const data = {
            pic_name: this.state.name,
            email: this.state.email,
            pic_phone: this.state.phone,
            updated_at: this.state.picData.updated_at
        }

        API_CONTACT.putDataEditPicContact(data, this.state.picData.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showEditPicModal: false
                })
                setTimeout(() => {
                    this.setState({ showSuccessAlert: false })
                    this.handleDetail(this.state.contactDetail.id)
                }, 1500)
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    handleLoadMore = async () => {
        await this.setState({
            page: this.state.page + 1
        })

        if (this.state.searchBy !== '' && this.state.keyword !== '') {
            return this.handleSearch(this.state.searchBy, this.state.keyword)
        }

        API_CONTACT.getListUserCustomer(this.state.page, this.state.limit, this.props.token)
            .then(res => {
                if (getContent(res).length === 0) {
                    return this.setState({
                        showLoadMore: false
                    })
                }
                let arr = this.state.contactList.concat(getContent(res))
                this.setState({
                    contactList: arr
                })
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateUserCustomer();
        this.getListUserCustomer();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate() {
        if (this.props.keyword !== '' && this.props.keyword !== undefined && this.props.keyword !== null) {
            this.handleDetailSearch();
        }
    }

    isActive = (contact) => {
        if (this.state.contactDetail.id === undefined) {
            return false
        }

        return contact.id === this.state.contactDetail.id
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[CONTACT_LIST_VIEW]} userPermission={this.props.userDetail.permissions}>
                <SearchbarMenu handleSearch={this.handleSearch} placeholder="Kata Kunci" />
                <div className="flex text-gray-600">
                    <div className="left w-4/12 bg-white rounded-lg p-5 mr-10 calculate-layout-contact">
                        <p className="text-xl font-medium px-2 pb-3">Daftar Kontak</p>
                        <div className="overflow-y-auto" style={{ height: "90%" }}>
                            {
                                this.state.total !== 0
                                    ? <div>
                                        {
                                            this.state.contactList.map(contact =>
                                                <div className="flex item-center border-t-2 border-gray cursor-pointer px-2 py-4" key={contact.id} id="btncontactdetail" onClick={() => this.handleDetail(contact.id)}>
                                                    <div className="bg-darkblue text-white flex items-center justify-center rounded-lg box">{contact.customer_name.charAt(0)}</div>
                                                    {
                                                        this.isActive(contact) ?
                                                            <div className="ml-3 select-none">
                                                                <p className="font-bold text-lightblue">{contact.customer_name}</p>
                                                                <p className="text-sm text-lightblue">{contact.customer_phone === '' ? "Nomor telepon tidak tercantum" : contact.customer_phone}</p>
                                                            </div>
                                                            :
                                                            <div className="ml-3 select-none">
                                                                <p className="font-bold">{contact.customer_name}</p>
                                                                <p className="text-sm">{contact.customer_phone === '' ? "Nomor telepon tidak tercantum" : contact.customer_phone}</p>
                                                            </div>
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                                    : <div className="w-full h-full flex justify-center items-center">
                                        <div className="px-3 py-5 text-center flex flex-col items-center">
                                            <IconNoContact />
                                            <p className="text-sm text-darkblue opacity-30 mt-5 select-none">Kontak Tidak Ditemukan</p>
                                        </div>
                                    </div>
                            }
                            <div className={this.state.showLoadMore && this.state.total > this.state.limit ? "flex justify-center" : "hidden"}>
                                <button type="button" id="btnmore" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-1" onClick={() => this.handleLoadMore()}>Tampilkan Lebih Banyak</button>
                            </div>
                        </div>
                    </div>
                    <CheckPermissionComponent permissionConstant={[CONTACT_LIST_VIEW]} userPermission={this.props.userDetail.permissions}>
                        {
                            this.state.isContactOpened ?
                                <div className="right w-8/12 bg-white rounded-lg p-5 overflow-y-auto calculate-layout-contact">
                                    <div className="flex">
                                        <div className="bg-darkblue text-white flex items-center justify-center rounded-lg box mt-1">{this.state.contactDetail.customer_name.charAt(0)}</div>
                                        <div className="ml-3 mb-5">
                                            <p className="text-2xl font-bold">{this.state.contactDetail.customer_name}</p>
                                            <p>
                                                {this.state.contactDetail.customer_phone === '' ? "Nomor telepon tidak tercantum" : this.state.contactDetail.customer_phone}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex justify-between w-full">
                                        <div className="w-1/2 ml-14 mr-5">
                                            <div className="flex items-center mb-5">
                                                <div className="mr-3">
                                                    <IconWarehouse />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Alamat Perusahaan</p>
                                                    <p className="text-sm">
                                                        {this.state.contactDetail.address === '' ? "Alamat tidak tercantum" : this.state.contactDetail.address}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center mb-5">
                                                <div className="mr-3">
                                                    <IconPhone />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Telepon Perusahaan</p>
                                                    <p className="text-sm">
                                                        {this.state.contactDetail.customer_phone === '' ? "Nomor telepon tidak tercantum" : this.state.contactDetail.customer_phone}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center mb-5">
                                                <div className="mr-3">
                                                    <IconEmail />
                                                </div>
                                                <div>
                                                    <p className="font-bold">Email Perusahaan</p>
                                                    <p className="text-sm">
                                                        {this.state.contactDetail.customer_email === '' ? "Email tidak tercantum" : this.state.contactDetail.customer_email}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            this.state.contactDetail.contact !== null &&
                                            <div className="w-1/2">
                                                <div className="flex mb-5">
                                                    <div className="mr-3">
                                                        <IconPeople />
                                                    </div>
                                                    <div>
                                                        {
                                                            this.state.contactDetail.contact !== null && this.state.contactDetail.contact.map((contact, idx) =>
                                                                <div className="mb-3" key={contact.id}>
                                                                    <p className="font-bold flex justify-between items-center">
                                                                        <span>PIC {idx + 1}</span>
                                                                        <CheckPermissionComponent permissionConstant={[CONTACT_LIST_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                                                            <FontAwesomeIcon icon={faEdit} className="text-lightblue cursor-pointer" id="btneditpic" onClick={() => this.handleEditPic(contact)} />
                                                                        </CheckPermissionComponent>
                                                                    </p>
                                                                    <p className="text-sm">{contact.pic_name}</p>
                                                                    <p className="text-sm">{contact.country_code}{contact.pic_phone}</p>
                                                                    <p className="text-sm">{contact.email}</p>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className={this.state.showEditPicModal ? "block" : "hidden"}>
                                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                            <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none p-10 w-1/4">
                                                <div className="header flex justify-between">
                                                    <div></div>
                                                    <FontAwesomeIcon icon={faTimes} className="cursor-pointer" id="btnclosepic" onClick={() => this.setState({ showEditPicModal: false })} />
                                                </div>
                                                <form onSubmit={this.handleSubmit}>
                                                    <p className="text-darkblue text-center text-3xl font-medium">Edit Kontak</p>
                                                    <label htmlFor="tslpicname">Nama PIC</label>
                                                    <input type="text" id="tslpicname" className="form-control mb-3" placeholder="Tulis Nama PIC" value={this.state.name} name="name" onChange={this.handleChange} autoComplete="off" />
                                                    <label htmlFor="tslpicphone">Telepon</label>
                                                    <div className="form-control mb-3">
                                                        <span className="mr-1">+62 |</span>
                                                        <input type="text" id="tslpicphone" className="outline-none custom-input w-4/5" placeholder="Tulis Nomor PIC" value={this.state.phone} name="phone" onChange={this.handleChange} autoComplete="off" />
                                                    </div>
                                                    <label htmlFor="tslpicemail">Email</label>
                                                    <input type="email" id="tslpicemail" className="form-control mb-3" placeholder="Tulis Email PIC" value={this.state.email} name="email" onChange={this.handleChange} autoComplete="off" />
                                                    <div className="flex justify-center items-center">
                                                        <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.setState({ showEditPicModal: false })}>Batal</button>
                                                        <button type="submit" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2">Simpan</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                    </div>
                                </div>
                                :
                                <div className="right w-8/12 flex flex-col justify-center items-center calculate-layout-contact">
                                    <IconContactCalendar />
                                    <p className="text-2xl text-darkblue opacity-30 mt-5">Temukan Kontak Distributor Anda</p>
                                </div>
                        }
                    </CheckPermissionComponent>
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Update Kontak!" />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);